import React from 'react';
import ReactToggle from 'react-toggle';
import * as Icon from 'react-feather';

const DefaultToggle = ({
  toggleWrapperClassName,
  onClick,
  withoutCheckIcon,
  ...props
}) => {
  return (
    <div className={toggleWrapperClassName}>
      <ReactToggle
        onClick={(e) => {
          e.stopPropagation();
          onClick(e.target);
        }}
        id="toggle"
        name="toggle"
        value="yes"
        icons={{
          ...(withoutCheckIcon && {
            checked: null,
            unchecked: null,
          }),
          ...(!withoutCheckIcon && {
            checked: (
              <Icon.Check
                size={13}
                style={{ position: 'absolute', top: '-2px', left: '2px' }}
                color="white"
              />
            ),
            unchecked: (
              <Icon.X
                size={13}
                style={{ position: 'absolute', top: '-2px', right: '-2px' }}
              />
            ),
          }),
        }}
        {...props}
      />
    </div>
  );
};

export default DefaultToggle;
